<template>
  <div class="AssetForm">
    <div>
      <div class="inline">
        <el-radio-group v-model="type_id">
          <el-radio-button :label="1">수입</el-radio-button>
          <el-radio-button :label="2">지출</el-radio-button>
        </el-radio-group>
      </div>
      <div class="inline pl-default">
        <el-radio-group v-model="account_type_id">
          <el-radio-button :label="1">현금</el-radio-button>
          <el-radio-button :label="2">통장</el-radio-button>
          <el-radio-button :label="3">카드</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div>
      <ATable
        v-loading="loading"
        ref="table"
        :data="filteredItems"
        :summaryTitleColumnIndex="3"
        :summaryFields="summaryFields"
        :disable_insert="!has_grant_write"
        hideButtonExcel
        hide-pagination
        hideButtonInsert
        show-summary
        border
        @cell-click="handleCellClick"
      >
        <el-table-column
          type="index"
          label="No"
          align="center"
          prop="index"
          :width="$width.index"
          :index="handleIndex"
        />
        <el-table-column label="계좌" prop="account_id" :width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.id === editingId">
              <el-select
                v-model="scope.row.account_id"
                size="tiny"
                :disabled="scope.row.id > 0"
              >
                <el-option
                  v-for="a in accountItems"
                  v-bind:key="a.id"
                  :value="a.id"
                  :label="a.name"
                />
              </el-select>
            </div>
            <div v-else>
              {{
                resolveAccount(scope.row, scope.column, scope.row.account_id)
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="주계정" prop="parent_id" :width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.id === editingId">
              <el-select
                size="tiny"
                v-model="parent_category_id"
                @change="handleChangeParentCategory"
              >
                <el-option
                  v-for="c in categoryParentItems"
                  v-bind:key="c.id"
                  :value="c.id"
                  :label="c.name"
                />
              </el-select>
            </div>
            <div v-else>
              {{ resolveParentCategory(scope.row) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="부계정" prop="category_id" :width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.id === editingId">
              <el-select
                size="tiny"
                v-model="scope.row.category_id"
                v-bind:class="{
                  'readonly-noborder': scope.row.id !== editingId,
                }"
                :readonly="scope.row.id !== editingId"
              >
                <el-option
                  v-for="c in categoryItems"
                  v-bind:key="c.id"
                  :value="c.id"
                  :label="c.name"
                />
              </el-select>
            </div>
            <div v-else>
              {{
                resolveCategory(scope.row, scope.column, scope.row.category_id)
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="customer_name" label="거래처" width="200" />
        <el-table-column label="비고" prop="desc">
          <template slot-scope="scope">
            <el-input
              size="mini"
              v-model="scope.row.desc"
              v-bind:class="{ 'readonly-noborder': scope.row.id !== editingId }"
              :readonly="scope.row.id !== editingId"
            />
          </template>
        </el-table-column>
        <el-table-column
          v-if="type_id === 1"
          label="수입액"
          prop="income"
          :width="100"
        >
          <template slot-scope="scope">
            <ANumberInput
              v-model="scope.row.income"
              v-bind:class="{ 'readonly-noborder': scope.row.id !== editingId }"
              :readonly="scope.row.id !== editingId"
              @keydown.enter.native="handleKeydownEnter(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column
          v-if="type_id === 2"
          align="right"
          label="지출액"
          prop="expense"
          :width="100"
        >
          <template slot-scope="scope">
            <ANumberInput
              v-model="scope.row.expense"
              v-bind:class="{ 'readonly-noborder': scope.row.id !== editingId }"
              :readonly="scope.row.id !== editingId"
              @keydown.enter.native="handleKeydownEnter(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="명령" width="150" v-if="has_grant_write">
          <template slot-scope="scope">
            <div v-show="scope.row.id === editingId">
              <el-button
                type="primary"
                size="mini"
                @click="handleClickRegister(scope.row)"
                >저장</el-button
              >
              <el-button size="mini" @click="calcelEditing(scope.row)"
                >취소</el-button
              >
            </div>
            <div
              v-show="
                scope.row.id !== editingId && scope.row.custom_flag === 'Y'
              "
            >
              <el-button
                type="danger"
                size="mini"
                @click="handleClickDelete(scope.row)"
                >삭제</el-button
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
      </ATable>
      <div slot="buttons">
        <el-button
          type="primary"
          v-shortkey="['f2']"
          :disabled="!has_grant_write"
          @shortkey.native="handleClickedCreate"
          @click="handleClickedCreate"
          >추가 (F2)</el-button
        >
        <el-upload
          class="inline"
          style="margin-left:10px"
          action="#"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="handleOnChange"
        >
          <el-button
            v-show="type_id === 2 && account_type_id === 3"
            :disabled="!has_grant_write"
            >카드 엑셀 등록</el-button
          >
        </el-upload>
      </div>
    </div>
    <div class="excel-info" v-if="excel_items.length > 0">
      <div class="excel-title">엑셀 등록 정보</div>
      <ATable
        v-loading="loading"
        ref="excel_table"
        v-if="excel_items.length > 0"
        :data="excel_items"
        hideTopPanel
        hideButtonExcel
        hide-pagination
        hideButtonInsert
        border
        @selection-change="handleSelectionChange"
      >
        >
        <el-table-column type="selection" width="30" />
        <el-table-column
          type="index"
          label="No"
          align="center"
          prop="index"
          :width="$width.index"
          :index="handleExcelIndex"
        />
        <el-table-column
          prop="deal_date"
          label="승인일"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column label="계좌" prop="account_id" :width="200">
          <template slot-scope="scope">
            <el-select v-model="scope.row.account_id" size="tiny">
              <el-option
                v-for="a in accountItems"
                v-bind:key="a.id"
                :value="a.id"
                :label="a.name"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="주계정" prop="parent_id" :width="150">
          <template slot-scope="scope">
            {{ resolveParentCategory(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="부계정" prop="category_id" :width="150">
          <template slot-scope="scope">
            <el-select size="tiny" v-model="scope.row.category_id">
              <el-option
                v-for="c in categoryItems"
                v-bind:key="c.id"
                :value="c.id"
                :label="c.name"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="비고" prop="desc">
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.desc" />
          </template>
        </el-table-column>
        <el-table-column
          align="right"
          label="지출액"
          prop="expense"
          :width="100"
        />
      </ATable>
      <div slot="buttons">
        <el-button
          v-if="excel_items.length > 0"
          type="primary"
          :disabled="selection.length < 1 || !has_grant_write"
          @click="handleClickExcelRegister"
          >등록</el-button
        >
        <el-button
          v-if="excel_items.length > 0"
          style="margin-left:10px"
          @click="handleClickExcelCancel"
          >취소</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { enter_tab } from "@/common/mixins/enter_tab";
import XLSX from "xlsx";

export default {
  name: "AssetForm",
  mixins: [enter_tab],
  data() {
    return {
      title: this.$t("title.asset_reg"),
      type_id: 2,
      account_type_id: 3,
      parent_category_id: 0,
      editingId: -1,
      oldItem: undefined,
      deleteItem: undefined,
      working: false,
      summaryFields: ["expense"],
      excel_items: [],
      selection: [],
    };
  },
  props: {
    items: {
      default: [],
    },
    date: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    type_id: function() {
      this.calcelEditing();
    },
    account_type_id: function() {
      this.calcelEditing();
    },
  },
  computed: {
    ...mapGetters(["table_account", "table_asset_category", "table_customer"]),
    filteredItems() {
      let accounts = this.table_account
        .filter((a) => {
          return a.use_flag === "Y" && a.type_id === this.account_type_id;
        })
        .map((a) => a.id);
      return this.items.filter((item) => {
        return (
          item.type_id === this.type_id && accounts.includes(item.account_id)
        );
      });
    },
    accountItems() {
      return this.table_account.filter((a) => {
        return a.use_flag === "Y" && a.type_id === this.account_type_id;
      });
    },
    categoryParentItems() {
      return this.table_asset_category
        .filter((c) => {
          return (
            c.use_flag === "Y" && c.type_id === this.type_id && !c.parent_id
          );
        })
        .sort(this.util.sortByName);
    },
    categoryItems() {
      return this.table_asset_category
        .filter((c) => {
          return c.use_flag === "Y" && c.parent_id === this.parent_category_id;
        })
        .sort(this.util.sortByName);
    },
  },
  methods: {
    calcelEditing(data) {
      if (!data) {
        data = this.oldItem;
      }
      if (data) {
        let index = this.items.findIndex((i) => i.id === data.id);
        if (this.oldItem.id) {
          this.items.splice(index, 1, this.oldItem);
        } else {
          this.items.splice(index, 1);
        }
      }
      this.editingId = -1;
    },
    doDelete() {
      this.api.deleteAsset(this.deleteItem).then((res) => {
        this.handleResponse(res, this.$t("message.success_delete"));
      });
    },
    resolveAccount(row, column, value) {
      let item = this.table_account.find((a) => a.id === value);
      return item ? item.name : "";
    },
    resolveParentCategory(row) {
      let item = this.table_asset_category.find(
        (a) => a.id === row.category_id
      );
      if (!item) {
        return "";
      }
      let parent = this.table_asset_category.find(
        (a) => a.id === item.parent_id
      );
      return parent ? parent.name : "";
    },
    resolveCategory(row, column, value) {
      let item = this.table_asset_category.find((a) => a.id === value);
      return item ? item.name : "";
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleCellClick(item, column) {
      if (!this.has_grant_write) {
        return;
      }
      if (this.editingId === item.id) {
        return;
      }
      if (this.editingId > -1) {
        this.calcelEditing();
      }
      if (!column.property) {
        return;
      }
      if (item.custom_flag !== "Y") {
        return;
      }
      let category = this.table_asset_category.find(
        (c) => c.id === item.category_id
      );
      let parent = this.table_asset_category.find(
        (c) => c.id === category.parent_id
      );
      this.parent_category_id = parent.id;
      this.editingId = item.id;
      this.oldItem = Object.assign({}, item);
    },
    handleClickedCreate() {
      if (!this.has_grant_write) {
        return;
      }
      if (this.editingId > -1) {
        this.calcelEditing();
      }
      this.editingId = 0;
      let account_id = this.accountItems[0] ? this.accountItems[0].id : null;
      if (!account_id) {
        this.util.notify_error(this, this.title, "등록된 계좌가 없습니다.");
        return;
      }
      if (this.type_id === 2 && this.account_type_id === 3) {
        //지출-카드시 카드대금을 기본으로 설정한다.
        this.parent_category_id = 15;
      } else {
        this.parent_category_id = this.categoryParentItems[0]
          ? this.categoryParentItems[0].id
          : null;
      }
      if (!this.parent_category_id) {
        this.util.notify_error(this, this.title, "등록된 주계정이 없습니다.");
        return;
      }
      let category_id = this.categoryItems[0] ? this.categoryItems[0].id : null;
      if (!category_id) {
        this.util.notify_error(this, this.title, "등록된 부계정이 없습니다.");
        return;
      }
      this.oldItem = {
        id: 0,
        deal_date: this.date,
        type_id: this.type_id,
        account_id: account_id,
        category_id: category_id,
        income: 0,
        expense: 0,
        desc: null,
      };
      this.items.push(this.oldItem);
    },
    handleChangeParentCategory() {
      this.oldItem.category_id =
        this.categoryItems.length > 0 ? this.categoryItems[0].id : null;
    },
    handleClickRegister(data) {
      if (this.working) {
        return;
      }
      if (!data.account_id) {
        this.util.notify_warning(this, this.title, "계좌를 선택해 주세요.");
        return;
      }
      if (!this.parent_category_id) {
        this.util.notify_warning(this, this.title, "주계정을 선택해 주세요.");
        return;
      }
      if (!data.category_id) {
        this.util.notify_warning(this, this.title, "부계정을 선택해 주세요.");
        return;
      }
      if (this.type_id === 1 && !data.income) {
        this.util.notify_warning(this, this.title, "수입액을 입력해 주세요.");
        return;
      } else if (this.type_id === 2 && !data.expense) {
        this.util.notify_warning(this, this.title, "지출액을 입력해 주세요.");
        return;
      }
      this.working = true;
      if (data.id) {
        this.api.updateAsset(data).then((res) => {
          this.working = false;
          this.handleResponse(res, this.$t("message.success_update"));
        });
      } else {
        this.api.createAsset(data).then((res) => {
          this.working = false;
          this.handleResponse(res, this.$t("message.success_create"), true);
        });
      }
    },
    handleClickDelete(data) {
      this.deleteItem = data;
      this.util.confirm_delete(this, this.title, this.doDelete);
    },
    handleResponse(res, message, add_new_row = false) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.editingId = -1;
      this.util.notify_success(this, this.title, message);
      this.$emit("completed", add_new_row);
    },
    handleKeydownEnter(data) {
      if (
        (this.type_id === 1 && !data.income) ||
        (this.type_id === 2 && !data.expense)
      ) {
        return;
      }
      this.handleClickRegister(data);
    },
    handleOnChange(event) {
      const file = event.raw;
      const reader = new FileReader();
      reader.onload = this.loadExcel;
      reader.readAsArrayBuffer(file);
    },
    loadExcel(e) {
      let tmpResult = {};
      let data = e.target.result;
      data = new Uint8Array(data);
      // get excel file
      let excelFile;
      try {
        excelFile = XLSX.read(data, { type: "array" });
      } catch (ex) {
        this.util.notify_error(this, this.title, "엑셀 파일이 아닙니다.");
        return;
      }
      // get prased object
      excelFile.SheetNames.forEach(function(sheetName) {
        const roa = XLSX.utils.sheet_to_json(excelFile.Sheets[sheetName], {
          header: [
            "permit_date",
            "permit_time",
            "part_number",
            "part_name",
            "card_num",
            "user_name",
            "customer_name",
            "business_type",
            "pay_way",
            "monthly_pay",
            "permit_price",
            "tax",
            "permit_part",
            "permit_way",
            "permit_num",
            "state",
            "tax_type",
            "customer_state",
            "customter_num",
            "customer_reg_num",
            "ceo_name",
            "customer_addr",
            "customer_tel",
          ],
        });
        if (roa.length) tmpResult[sheetName] = roa;
      });
      this.parseExcel(tmpResult.Sheet1);
    },
    parseExcel(result) {
      this.parent_category_id = 15;
      let category_id = this.categoryItems[0] ? this.categoryItems[0].id : null;
      // 헤더 정보 제거
      result.splice(0, 1);
      result.forEach((item) => {
        let account_id = this.table_account.find(
          (findItem) =>
            findItem.number &&
            findItem.number.split("-")[3] === item["card_num"].split("-")[3]
        );
        if (!account_id) {
          this.util.notify_error(
            this,
            this.title,
            "[" + item["customer_name"] + "]에 대한 등록된 계좌가 없습니다."
          );
          return;
        }
        let data = {
          deal_date: item["permit_date"].replaceAll(".", "-"),
          type_id: this.type_id,
          account_id: account_id.id,
          category_id: category_id,
          expense: item["permit_price"],
          desc: item["customer_name"],
        };
        this.excel_items.push(data);
      });
    },
    handleClickExcelRegister() {
      if (this.working) {
        return;
      }
      this.selection.forEach((data) => {
        if (!data.account_id) {
          this.util.notify_warning(
            this,
            this.title,
            "[" + data.desc + "] 계좌를 선택해 주세요."
          );
          return;
        }
        if (!data.category_id) {
          this.util.notify_warning(
            this,
            this.title,
            "[" + data.desc + "] 부계정을 선택해 주세요."
          );
          return;
        }
      });
      this.working = true;
      this.api.createAsset(this.excel_items).then((res) => {
        this.working = false;
        this.excel_items = [];
        this.selection = [];
        this.handleResponse(res, this.$t("message.success_create"));
      });
    },
    handleExcelIndex(index) {
      return this.$refs.excel_table.indexResolver(index);
    },
    handleClickExcelCancel() {
      this.excel_items = [];
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
  },
};
</script>

<style lang="scss" scoped>
.excel-title {
  font-size: 13px;
  font-weight: bold;
}
.excel-info {
  border: 1px solid;
  border-radius: 4px;
  padding: 10px;
  margin-top: 20px;
}
</style>
